<template>
	<!-- <div class="ptlr-60-16 box-s"> -->
	<div class="box-s">
    <!-- <div class="bg_f ps_top">
		<NavList :navList="navList" @getItem="getItem"></NavList>
	</div> -->

			<ul>
        <li class="list_every pd-16 box-s mb-16" v-for="(item, index) in list" :key="index">
          <div class="flexs flex-jus mb-16">
             <div class="flexs">
							 <img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/test_q_icon.png" alt="">
							 <div class="fw-500 fz-16 c1 w157 text-hide">{{item.name}}</div>
						 </div>

						 <div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" @click="getStrat(item)"> 
								开始刷题
								<img class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
							</div>
					</div>

					<div class="flexs c1fw-500 fz-14 l-h-46 plr-16 box-s bg_f9 b-radius-6">
						<div class="flex1">题目数量： {{item.nums}}题</div>
						<div class="flex1">已刷数量： {{item.complete}}题</div>
					</div>
				</li>
			</ul>
			<noData v-if="show"></noData>
		  <loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
  import noData from "@/components/noData"
  import loading from "@/components/loading"
	import {gateLevelSubject, siteListsV2} from '@/api/api'
	import NavList from '@/components/navList'
	export default {
		components: {
			NavList,
			loading,
			noData
		},
		data() {
			return {
			  navList: [],
				list: [],
				show: false,
				loadFlag: false,
			};
		},
		created() {
      		//this.initSubJectData()
			
			this.initData(this.$route.query.place_id)
		},
		mounted(){
		},
		methods: {
			// 初始化科目列表
			async initSubJectData(){
        		const res = await gateLevelSubject()
				if( res.code == 1000 ){
          		this.navList = res.data
					this.initData(this.navList[0].id)
				} else {
					this.$toast(res.msg)
				}
			},
      
			// 初始化题列表
			// async initData(subject_id){
			// 	this.loadFlag = true
        	// 	const res = await siteLists({ subject_id })
			// 	this.loadFlag = false
			// 	if( res.code == 1000 ){
			// 		this.list = res.data
			// 		if(this.list.length == 0){
            // 			this.show = true
			// 		}
			// 	}else {
			// 		this.$toast(res.msg)
			// 	}
			// },

			//改为调取该考点下的
			async initData(place_id){
				this.loadFlag = true
        		const res = await siteListsV2({ place_id })
				this.loadFlag = false
				if( res.code == 1000 ){
					this.list = res.data
					if(this.list.length == 0){
            			this.show = true
					}
				}else {
					this.$toast(res.msg)
				}
			},
      
			// 切换导航
			getItem(data){
				this.show = false
				this.initData(data.item.id)
			},
      
			// 开始答题
			getStrat(data){
				console.log(data)
				if(data.nums == 0){
          return this.$toast('暂无题目，无法开始做题哦~')
				}
        this.$router.push({ path: '/testquesttxt', query: { examination_id: data.id } })
			}

		}
	};
</script>
<style lang="less" scoped>
</style>
